import { render, staticRenderFns } from "./ProcessesList.vue?vue&type=template&id=347979cc&scoped=true"
import script from "./ProcessesList.ts?vue&type=script&lang=ts&external"
export * from "./ProcessesList.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessesList.vue?vue&type=style&index=0&id=347979cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347979cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347979cc')) {
      api.createRecord('347979cc', component.options)
    } else {
      api.reload('347979cc', component.options)
    }
    module.hot.accept("./ProcessesList.vue?vue&type=template&id=347979cc&scoped=true", function () {
      api.rerender('347979cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Processes/components/list/ProcessesList/ProcessesList.vue"
export default component.exports